import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CarrierLoadEditService,
  CarrierLoadModel,
  CustomerLoadAddRequest,
  CarrierLoadListModel,
  LoadBoardSortRequest,
  CustomerLoadDetailsRequest,
  CustomerLoadEditStopsRequest,
  LoadStatus
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsVoidType, RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CarrierLoadEditApiService {
  constructor(private apiService: CarrierLoadEditService) {}

  public markLoadHistory(loadId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.carrierLoadActiveMarkHistory(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public markLoadAsPaid(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadActiveMarkPaid(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public addLoad(carrierId: string, body: CustomerLoadAddRequest, customerId?: string, driverId?: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadAdd(carrierId, body, customerId, driverId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public removeFromBoard(loadId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.carrierLoadBoardArchive(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public cancelLoadPermanently(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadCancelPermanently(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public acceptLoadCancelRequest(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadCancelRequestAccept(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteLoad(loadId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.carrierLoadDelete(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setBoardSort(body: LoadBoardSortRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadListModel> {
    return this.apiService.carrierLoadEditBoardSortOrder(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editLoadDetails(loadId: string, body: CustomerLoadDetailsRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadEditDetails(loadId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setPlannedRoute(loadId: string, value: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadEditDirectionData(loadId, { value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editLoadDraft(loadId: string, body: CustomerLoadAddRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadEditDraft(loadId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editRoute(loadId: string, body: CustomerLoadEditStopsRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadEditRoute(loadId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editLoadStatus(loadId: string, status: LoadStatus, driverId?: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadEditStatus(loadId, status, driverId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public inviteLoadSupport(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadInviteSupport(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setStopArrived(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadStopArrived(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setStopCompleted(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadStopCompleted(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setStopGood_to_go(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadStopGoodToGo(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setStopOnRoute(loadId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadModel> {
    return this.apiService.carrierLoadStopOnRoute(loadId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
